import React, { useState } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import CommentItem from '@components/Comments/CommentItem';
import BookingEventCommentForm from '@components/EventDrawer/BookingEvent/BookingEventComments/BookingEventCommentForm';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import { NWListItem } from '@components/Gui/NWList';
import Visibilities from '@components/Gui/Visibilities';
import ObjectLogHistories from '@components/ObjectLogHistories/ObjectLogHistories';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .itemActions {
        padding-left: 8px;
    }
`;

const ProjectComment = ({ comment, onUpdate, disableVisibility, project, events, modelId }) => {
    const [loading, setLoading] = useState(false);
    const [touchForm, setTouchForm] = useState(false);
    const [editingMode, setEditingMode] = useState(false);

    const deleteComment = async (commentId) => {
        setLoading(true);
        await Axios.delete(`/comments/${commentId}`)
            .then(() => {
                onUpdate();
            })
            .catch((error) => {
                console.error('errore', error);
            });
        setLoading(false);
    };

    const handleCloseAddForm = () => {
        setEditingMode(false);
    };

    return (
        <>
            <div className="grid-card-body">
                <CommentItem item={comment} disableVisibility={true} events={events} rows={6} />
            </div>
            <div className="grid-card-footer">
                <NwDropDownMenu
                    loading={loading}
                    actions={[
                        {
                            name: '',
                            key: 'edit',
                            pinned: true,
                            icon: byPrefixAndName.fasl['pen'],
                            action: () => setEditingMode(true),
                        },
                        {
                            name: 'delete',
                            type: 'delete',
                            key: 'delete',
                            icon: byPrefixAndName.fasl['trash-alt'],
                            confirmationPlacement: 'left',
                            action: () => {
                                deleteComment(comment.ID);
                            },
                        },
                    ]}
                />
                {!disableVisibility && <Visibilities visibilities={comment.Visibility.Areas} />}
            </div>
            {editingMode && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Edit comment"
                    onClose={handleCloseAddForm}
                >
                    <BookingEventCommentForm
                        events={events}
                        modelId={modelId}
                        api="ProjectID"
                        project={project}
                        noPadding
                        disableVisibility
                        onSave={(save) => {
                            if (save) {
                                onUpdate();
                            }
                            handleCloseAddForm();
                        }}
                        itemToEdit={comment}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
        </>
    );
};

export default ProjectComment;
